export enum OrderConfirmationActionTypes {
  ORDER_CONFIRMATION_SUCCESS = "ORDER_CONFIRMATION_SUCCESS",
  ORDER_CONFIRMATION_ERROR = "ORDER_CONFIRMATION_ERROR",
  ORDER_CONFIRMATION_RESET_STATE = "ORDER_CONFIRMATION_RESET_STATE",
}
